import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/tribeca-logo.PNG"
          width="150px"
          height="70px"
          loading="lazy"
          alt="logo"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={handleShowModal}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Founded in 2012, Tribeca is India's foremost design-led luxury real
        estate developer, best known for developing the largest Trump Towers
        portfolio globally, and for redefining the term “Trophy Properties.”
        With an eye for international standards and a legacy of architectural
        excellence, Tribeca creates properties that not only elevate lifestyles
        but become global landmarks.
        <br />
        Tejukaya Group, a legacy brand since 1887, has been instrumental in
        shaping India's infrastructure landscape - from building the iconic
        Elphinstone Bridge and Tansa Dam to redefining urban Mumbai through
        landmark projects. Their unmatched commitment to quality and innovation
        now reflects in this collaboration with Tribeca at The Edge, Lalbaug.
      </p>

      <div className="rera-numbers">
        <div className="rera-item">
          <img src="images/rera-P51900032613.jpg" alt="rera qr" />
          <strong>P51900032613</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <p></p>
      <button
        className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
